import { Nullable } from '../../types/common'
import Sidebar from '../sidebar/sidebar'

class ProductInformationDrawer extends Sidebar {
  viewport: Nullable<HTMLFormElement>

  constructor() {
    super()

    this.viewport = this.element.querySelector(
      '[data-product-information-drawer-viewport]',
    )
  }

  connectedCallback(): void {
    super.connectedCallback()

    this.viewport.addEventListener('scroll', this.handleFormScroll)
  }

  disconnectedCallback(): void {
    super.disconnectedCallback()

    this.viewport.removeEventListener('scroll', this.handleFormScroll)
  }

  handleFormScroll = (): void => {
    if (!this.viewport) {
      return
    }

    const isScrolled = this.viewport.scrollTop > 0

    this.toggleAttribute('header-shadow-visible', isScrolled)
  }
}

export default ProductInformationDrawer
